import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Grid, TextField, MenuItem, Button,
   Typography, FormGroup, FormControlLabel,  } from "@mui/material";
import { LocalTaxiRounded, ScheduleRounded, ChecklistRtlRounded } from "@mui/icons-material";
import {useMapsLibrary } from '@vis.gl/react-google-maps';
import countryCodeData from "./countryCode/index.json";
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import Assigndriver from "./Assigndriver";
// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

//Services
import DispatcherApi from "Services/Dispatcher";

const CreateTrip = ({ 
  destination , dropLatLng , pickupLatLng, distance , travelDuration , origin ,
  activecarouselRef ,userType , subcmpnyName
 }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles(); 
  const[autoassign,setAutoassign]=useState(false);
  const [assigndriverModal, setAssigndriverModal] = useState(false);
  const [dialogFormValues, setDialogFormValues] = useState({});
  
   const handleautoassign = () => {
    setAutoassign((prev) => !prev);
  };
  
  const handleCloseassignModal = () => {
  setAssigndriverModal(false);
  };
  
  const handledisagreeassignModal = () => {
    setAssigndriverModal(false);
  }
  
  const handlecreatetrip = (formValues) => {
    //console.log('activecarouselservice-->',activecarouselRef);
    formValues.bookingType="USER";
    formValues.d_address=destination;
    formValues.d_latitude=dropLatLng.lat;
    formValues.d_longitude=dropLatLng.lng;
    formValues.distance=distance;
    formValues.minutes=travelDuration;
    formValues.s_address=origin;
    formValues.s_latitude=pickupLatLng.lat;
    formValues.s_longitude=pickupLatLng.lng;
    formValues.service_type=activecarouselRef.current?.service_id;
    formValues.estimatedFare=activecarouselRef.current?.estimated_fare;
    formValues.autoassigndriver=autoassign;
    formValues.userType=userType;
    formValues.subcmpnyName=subcmpnyName;

   // console.log('formValues-->',formValues);
      dispatch(showLoader("Loading please wait..."));
  
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: res?.data?.message || "Ride created successfully",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            })
          );
          formik.resetForm();
          navigate('/triplist');
        }
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while creating ride",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "error",
          })
        );
        formik.resetForm();
        const pickupInput = document.getElementById("pickuplocation");
        const dropInput = document.getElementById("droplocation");
      
        if (pickupInput) {
          pickupInput.value = ""; // Clear the value of the pickup location field
        }
      
        if (dropInput) {
          dropInput.value = ""; // Clear the value of the drop location field
        }
      };
      if(formValues.autoassigndriver){
      DispatcherApi.createridebydispatcher({ ...formValues }).then(onSuccess, onFailure);
      }
      else{
        setDialogFormValues(formValues);
        setAssigndriverModal(true);
      }
  };
  
   const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      promo_code: "",
      provider_id: "",
      service_type: "",
      s_latitude:"",
      s_longitude:"",
      s_address:"",
      d_latitude:"",
      d_longitude:"",
      d_address:"",
      distance:"",
      minutes:"",
      bookingType:"",
      userNotes:"",
      countryCode:"",
    },
    validationSchema: yup.object({
      first_name: yup.string().required("First Name is required").nullable(),
      countryCode: yup.string().required("Country Code is required").nullable(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required")
        .nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Mobile is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlecreatetrip(values); // Ensure this processes `values` correctly
    },
    });

    return (
<>
<Grid container rowSpacing={1} className={classes.containerformik} >

<Grid item xs={6} className={classes.formikgrids} >
 <TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="first_name"
    label="First Name"
    value={formik?.values?.first_name}
    defaultValue={formik?.values?.first_name}
    onChange={formik.handleChange}
    error={
      formik?.errors?.first_name &&
      formik?.touched?.first_name
    }
    helperText={
      formik?.errors?.first_name &&
      formik?.touched?.first_name &&
      formik?.errors?.first_name
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>
<Grid item xs={6} className={classes.formikgrids}>
<TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="last_name"
    label="Last Name"
    value={formik?.values?.last_name}
    defaultValue={formik?.values?.last_name}
    onChange={formik.handleChange}
    error={
      formik?.errors?.last_name &&
      formik?.touched?.last_name
    }
    helperText={
      formik?.errors?.last_name &&
      formik?.touched?.last_name &&
      formik?.errors?.last_name
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>
<Grid item xs={12} className={classes.formikgrids} >
<TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="email"
    label="Email"
    value={formik?.values?.email}
    defaultValue={formik?.values?.email}
    onChange={formik.handleChange}
    error={
      formik?.errors?.email &&
      formik?.touched?.email
    }
    helperText={
      formik?.errors?.email &&
      formik?.touched?.email &&
      formik?.errors?.email
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>
<Grid item xs={6} className={classes.formikgrids}>
<TextField
inputProps={{
      disableUnderline: false,
form: {
    autocomplete: 'off',
  },
}}
name="countryCode"
id="countryCode"
label="Country Code"
value={formik?.values?.countryCode}
defaultValue={formik?.values?.countryCode}
onChange={formik?.handleChange}
select
error={
formik?.errors?.countryCode &&
formik?.touched?.countryCode
}
helperText={
formik?.errors?.countryCode &&
formik?.touched?.countryCode &&
formik?.errors?.countryCode
}
fullWidth
variant="standard"
size="small"
>
{countryCodeData?.map((country) => (
<MenuItem
  key={country.code}
  value={country.dial_code}
>
  {`${country.code} (${country.dial_code})`}
</MenuItem>
))}
</TextField>  
</Grid>
<Grid item xs={6} className={classes.formikgrids}>
<TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="mobile"
    label="Mobile"
    value={formik?.values?.mobile}
    defaultValue={formik?.values?.mobile}
    onChange={formik.handleChange}
    error={
      formik?.errors?.mobile &&
      formik?.touched?.mobile
    }
    helperText={
      formik?.errors?.mobile &&
      formik?.touched?.mobile &&
      formik?.errors?.mobile
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>
<Grid item xs={12}className={classes.formikgrids}>
<TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="userNotes"
    label="userNotes"
    value={formik?.values?.userNotes}
    defaultValue={formik?.values?.userNotes}
    onChange={formik.handleChange}
    error={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes
    }
    helperText={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes &&
      formik?.errors?.userNotes
    }
    fullWidth
    variant="standard"
    size="small"
  ></TextField>
</Grid>
<Grid item xs={12} className={classes.switchWrapper}>
<Typography variant="body1">
  Autoassign driver
</Typography>
  <FormControlLabel
    control={
      <CustomSwitch
        checked={autoassign}
        onChange={() => handleautoassign()}
      />
    }
  />
</Grid>

<Grid item xs={12} className={classes.switchWrapper} >
<Button variant="contained" onClick={formik?.handleSubmit}>
Create trip
</Button>
</Grid>

<Assigndriver
userType={userType} 
subcmpnyName={subcmpnyName}
openDialog={assigndriverModal}
formvalues={dialogFormValues}
handleClose={handleCloseassignModal}
handledisagree={handledisagreeassignModal}
></Assigndriver>

</Grid>
</>
);
};

export default CreateTrip;